import { render, staticRenderFns } from "./registrationPayDialog.vue?vue&type=template&id=40162121&scoped=true"
import script from "./registrationPayDialog.vue?vue&type=script&lang=js"
export * from "./registrationPayDialog.vue?vue&type=script&lang=js"
import style0 from "./registrationPayDialog.vue?vue&type=style&index=0&id=40162121&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40162121",
  null
  
)

export default component.exports